export default {
  accueil: {
    title: '<b>Accueil</b> (Accès rapide)',
    derniereConnexion: 'Dernière connexion',
    premiereConnexion: "C'est votre première connexion",
    bilanEnCours: 'Mon bilan en cours',
    typeVisite: 'Type de la visite',
    visite1: 'Examen à jeun',
    visite2: 'Consultation',
    visite3: 'Gynécologie',
    mammo: 'Mammographie',
    dateMammo: 'Indiquer date mammo',
    dateDerniereMammo: 'Date de dernière mammographie',
    dureePrevisionnelle: 'Fin estimée à',
    osteo: 'Ostéodensitométrie',
    dateEtEtatVisite: 'Date et Etat de la visite',
    pasDeBilan: "Aucun Bilan n'est en cours",
    mesNouveauxDocuments: 'Mes derniers documents',
    plusDocuments: 'Plus de documents',
    activationDMC: {
      activeDmc:
        "Vous n'avez pas activé la publication des informations de votre dossier médical sur Extraciem. <br>Vous pouvez modifier votre choix et autoriser la mise à disposition des documents à l'aide du bouton ci-dessous",
      activeDmcBtn: 'Activer mon dossier médical',
      error: "Erreur technique pendant l'activation du dossier médical",
    },
    documentsCiem: {
      titre: 'Liste des documents CIEM',
      headers: {
        documentName: 'Document',
        download: 'Télécharger',
      },
    },
    documents: {
      headers: {
        typeDocument: 'Type du document',
        dateCreation: 'Date du document',
        libelleDocument: 'Libellé',
        download: 'Télécharger',
        annexes: 'Annexes',
      },
    },
    correspondant: {
      administration: {
        titre: 'Administration',
        etablissementRattachement: 'Votre établissement de rattachement',
        aucunEtablissementRattachement:
          "Vous n'êtes rattaché à aucun établissement",
        entrepriseInseeRattachement: 'Votre entreprise de rattachement',
        groupementRattachement: 'Votre groupement de rattachement',
        aucuneEntrepriseInseeRattachement:
          "Vous n'êtes rattaché à aucune entreprise",
      },
      mutationsEnCours: {
        titre: 'Mutations cours',
        entrantes: 'Mutations entrantes',
        nombreEntrantes: 'Il y a {0} mutation(s) entrantes',
        sortantes: 'Mutations sortantes',
        nombreSortantes: 'Il y a {0} mutation(s) sortantes',
        nombreMutation: 'Il y a {0} mutation(s) en cours',
      },
    },
    error: {
      detail:
        "Une erreur est survenue lors de la récupération des informations de l'accueil",
    },
  },
}
